import React from 'react';


class Databasecinegon extends React.Component{
    render(){
        return (
            <React.Fragment>
              <div className="Page">
                 <div className="OneApp">
                        <h5>Cinegon data base</h5>
                        
                        
                        <img src="https://raw.githubusercontent.com/BrandonGrimaldoM/CinegonDataBase/master/BD/ERM.PNG" width="700" height="560" align="center" alt="cine"/>
                        
                        
                        
                        
                        <p align="left">Esta base de datos en Oracle pertenece a la aplicación Cinegon</p>
                        
                        <p align="left">Puedes ver el repositorio dando click <a href="https://github.com/BrandonGrimaldoM/CinegonDataBase" target="_blank" rel='noreferrer'>AQUI.</a></p>
                        
                        <div className="space"></div>
                        
                        
                 </div>
                 
                
             </div>
          
            </React.Fragment>
        ); 
    }
}

export default Databasecinegon;